export default __webpack_public_path__ + "static/media/Prasad.3fab96b9.png";